"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalStyles = void 0;
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = require("styled-components");
exports.GlobalStyles = (0, styled_components_1.createGlobalStyle) `
  html {
    font-family: 'Main CA Font', sans-serif;
  }
  
  body {
    margin: 0;
  }
  
  input {
    font-family: 'Main CA Font', sans-serif;
  }

  button {
    font-family: 'Main CA Font', sans-serif;
  }
  
  button:focus-visible {
    outline: 2px solid ${ui_1.darkTheme.designSystem.accent};
    outline-offset: 6px;
  }

  @supports not selector(:focus-visible) {
    button:focus {
      /* Fallback for browsers without :focus-visible support */
      outline: 2px solid ${ui_1.darkTheme.designSystem.accent};
      outline-offset: 6px;
    }
  }

  *::-webkit-scrollbar {
    width: 8px;
    background-color: transparent;
  }

  *::-webkit-scrollbar-thumb {
    background-color: ${ui_1.darkTheme.userOnboarding.scrollbarThumb}; //.scrollview
    border-radius: 6px;
  }
`;
